/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */ import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBullhorn,
  faChevronRight,
  faBell,
} from '@fortawesome/free-solid-svg-icons';
import ShowMoreView from './showmoreview';
import CarouselSlider from './carouselslider';
library.add(faBullhorn, faChevronRight, faBell);

export const CoverageSlider = (props) => {
  console.log('CoverageSlider');
  return (
    <div className="h-100">
      <div className="d-none d-sm-block">
        <CarouselSlider key={''} />
      </div>
      <div className="d-block d-sm-none">
        <ShowMoreView />
      </div>
    </div>
  );
};
export default CoverageSlider;
